import classNames from 'classnames';
import PropTypes from 'prop-types';
import SidebarContent from './SidebarContent';

const Sidebar = ({
  changeMobileSidebarVisibility,
  sidebarShow,
  sidebarCollapse,
}) => {
  const sidebarClass = classNames({
    sidebar: true,
    'sidebar--show': sidebarShow,
    'sidebar--collapse': sidebarCollapse,
  });

  return (
    <div className={sidebarClass}>
      {/* <button
        type='button'
        className='sidebar__back'
        onClick={changeMobileSidebarVisibility}
      /> */}
      <div className='sidebar__scroll scroll'>
        <div className='sidebar__wrapper sidebar__wrapper--desktop'>
          <SidebarContent onClick={() => {}} />
        </div>
        <div className='sidebar__wrapper sidebar__wrapper--mobile'>
          <SidebarContent onClick={changeMobileSidebarVisibility} />
        </div>
      </div>
    </div>
  );
};

Sidebar.propTypes = {
  sidebarShow: PropTypes.bool.isRequired,
  sidebarCollapse: PropTypes.bool.isRequired,
  changeMobileSidebarVisibility: PropTypes.func.isRequired,
};

export default Sidebar;
